import {Swiper,  Navigation, Pagination } from "swiper/core";
import jQuery from "jquery";

Swiper.use([Navigation, Pagination]);


jQuery(document).ready(function(){

  const swiperSliders = document.querySelectorAll(
    ".lg-advanced-slider"
  );
  
  
  console.log("View Script for Slider Loaded!");
  console.log(swiperSliders);
  
  window.test = swiperSliders;
  
  swiperSliders.forEach((swiperSlider, index) => {
    let children = swiperSlider.childNodes;
  
    if (children.length > 1) {
      window.advancedslider = [];
      window.advancedslider[index] = {};
  
      let thumbConfig = JSON.parse(swiperSlider.children[1].dataset.swiper);
      let mainConfig = JSON.parse(swiperSlider.children[0].dataset.swiper);
  
      thumbConfig.slidesPerView = 6;
      thumbConfig.effect = "fade";
      thumbConfig.fadeEffect = { crossFade: true };
  
      const thumb = new Swiper(swiperSlider.children[1], thumbConfig);
  
      mainConfig.effect = "fade";
      mainConfig.fadeEffect = { crossFade: true };
  
      console.log(mainConfig);
  
      const main = new Swiper(swiperSlider.children[0], mainConfig);
      main.allowSlideNext = true;
      console.log
  
      thumb.on("click", function(e) {
        main.slideTo(e.clickedIndex);
        thumb.activeIndex = e.clickedIndex;
        main.activeIndex = e.clickedIndex;
        thumb.realIndex = e.clickedIndex;
        main.realIndex = e.clickedIndex;
        thumb.updateSlidesClasses();
      });
  
      thumb.on("realIndexChange", function(e) {
        thumb.activeIndex = e.clickedIndex;
        thumb.updateSlidesClasses();
      });
  
      thumb.on("slideChange", function(e) {
        thumb.activeIndex = e.clickedIndex;
        thumb.updateSlidesClasses();
      });
  
      main.on("slideChange", function(e) {
        thumb.activeIndex = main.activeIndex;
        //     thumb.realIndex = main.activeIndex;
        thumb.updateSlidesClasses();
      });
  
      thumb.allowTouchMove = false;
  
      window.advancedslider[index].thumb = thumb;
      window.advancedslider[index].main = main;
    } else {
      console.log("Not a thumb slider!");
      let swiperConfig = JSON.parse(swiperSlider.children[0].dataset.swiper);
      swiperConfig.cssMode = true;
      swiperConfig.grabCursor = true;
      swiperConfig.thumbs = undefined;

      if (window.advancedslider === undefined) {
        window.advancedslider = [];
      }
  
      window.advancedslider[index] = new Swiper(
        swiperSlider.children[0],
        swiperConfig
      );
    }
  });


});


